module.exports = __webpack_public_path__ + "img/close_btn_h.5f75d76.png";